import styled from 'styled-components';

export const HorizontalSectionCoverStyle = styled.div`
  display: flex;
  column-gap: 10px;
  overflow: auto;
  padding: 10px;
`;

export const SubHeadingStyle = styled.h2`
  color: rgba(0, 0, 0, 0.8);
  position: relative;
  font-size: clamp(20px, 2vw, 26px);
  font-weight: bold;
  text-transform: capitalize;
  margin-bottom: 10px;
  padding: 0 16px;
`;

export const SubHeadingDescriptionStyle = styled.h3`
  color: rgba(0, 0, 0, 0.8);
  position: relative;
  font-size: clamp(16px, 2vw, 20px);
  margin-bottom: 10px;
  padding: 0 16px;
`;
